export const GITHUB_OWNER = 'simonhackler';
export const GITHUB_REPO = 'digitable';
export const DISCORD_URL = 'https://discord.gg/sasxJ5MRWX';
export const GITHUB_URL = `https://github.com/${GITHUB_OWNER}/${GITHUB_REPO}`;
